import React from 'react';
import './scrolldown.css';

function ScrollDown({ onClick }) {
  return (
    <section className="arrow-down" onClick={onClick}>
      <a>
        <span />
        <span />
        <span />
        Scroll
      </a>
    </section>
  );
}

export default ScrollDown;
